/**
 * ScrollMonitor
 *
 * @since 1.0.0
 */
import scrollMonitor from 'scrollmonitor'

const ScrollMonitor = () => {
  const monitors = document.querySelectorAll('.js-scroll-animation')

  if (monitors.length) {
    ;[...monitors].forEach(monitor => {
      const watcher = scrollMonitor.create(monitor, -100)
      watcher.enterViewport(() => {
        if (monitor.classList.contains('js-scroll-target')) {
          monitor.classList.add('u-animate--active')
        } else {
          const targets = monitor.querySelectorAll('.js-scroll-target')
          ;[...targets].forEach((target, index) => {
            window.setTimeout(() => {
              target.classList.add('u-animate--active')
            }, 200 * index)
          })
        }
        watcher.destroy()
      })
    })
  }
}

export default ScrollMonitor



// WEBPACK FOOTER //
// ./src/js/modules/ScrollMonitor.js